import React from 'react';
import { render } from 'react-dom';
import BeefBracketApp from './apps/BeefBracket/BeefBracketApp';

// Interests Application
const beefBracketApp = document.getElementById('beef-bracket-app');
// Preset view for Beef Bracket App
if (beefBracketApp)
  render(<BeefBracketApp {...beefBracketApp.dataset} />, beefBracketApp);

// Display view for Beef Bracket Tablet
const beefBracketAppTablet = document.getElementById('beef-bracket-app-tablet');
if (beefBracketAppTablet)
  render(
    <BeefBracketApp {...beefBracketAppTablet.dataset} view="tablet" />,
    beefBracketAppTablet
  );
